var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-dual"},[_c('div',{staticClass:"lds-dual-ring",class:_vm.extra_classes})])
}
var staticRenderFns = []

export { render, staticRenderFns }